/*
 * Copyright (c) Worldline 2023.
 */

export const CustomErrors = {
    invalidSession: 'invalidSession',
    unexpectedError: 'unexpectedError',
    unknownError: 'unknownError',
    unreachableService: 'unreachableService',
    totalSubmissionLimitOtp: 'totalSubmissionLimitOtp',
    evidenceError: 'evidenceError',
    cancellationError: 'cancellationError',
    totalSSOLimit: 'totalSSOLimit'
};
